export const serializeParams = params => {
  const keys = Object.keys(params);
  let options = '';
  keys.forEach(key => {
    if (Array.isArray(params[key])) {
      params[key].forEach(element => {
        options += `${key}=${element}&`;
      });
    } else options += `${key}=${params[key]}&`;
  });
  return options ? options.slice(0, -1) : options;
};
